import React from 'react';

const CourseHeaderContent = ({ course, formatCurrency }) => {
  // Helper function to format price in Pakistani Rupees
  const formatPriceInRupees = (price) => {
    if (!price && price !== 0) return 'Rs 0';
    
    // If formatCurrency already adds $, we need to remove it and replace with Rs
    const formatted = formatCurrency(price);
    
    // Check if the formatted string starts with $ and replace it with Rs
    if (formatted.startsWith('$')) {
      return `Rs ${formatted.substring(1)}`;
    }
    
    // If it doesn't start with $, just add Rs prefix
    return `Rs ${formatted}`;
  };

  return (
    <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden mb-6 sm:mb-8">
      <div className="relative">
        <img
          src={course.thumbnailUrl}
          alt={course.title}
          className="w-full h-48 sm:h-56 md:h-64 object-cover"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80';
          }}
        />
        <div className="absolute top-4 right-4 flex space-x-2">
          {course.promoPrice ? (
            <>
              <span className="px-3 py-1 bg-red-500 text-white rounded-full text-sm font-semibold">
                {formatPriceInRupees(course.promoPrice)}
              </span>
              <span className="px-3 py-1 bg-gray-800 text-white rounded-full text-sm font-semibold line-through">
                {formatPriceInRupees(course.price)}
              </span>
            </>
          ) : (
            <span className="px-3 py-1 bg-green-500 text-white rounded-full text-sm font-semibold">
              {formatPriceInRupees(course.price)}
            </span>
          )}
          <span className="px-3 py-1 bg-black bg-opacity-70 text-white rounded-full text-sm font-semibold">
            {course.totalStudents} Students
          </span>
        </div>
      </div>
      
      <div className="p-6 sm:p-8">
        <div className="flex flex-wrap items-center justify-between mb-4 gap-2">
          <div className="flex items-center space-x-2">
            <span className="text-sm font-semibold text-green-600 bg-green-50 px-3 py-1 rounded-full">
              {course.category}
            </span>
            {course.levelName && (
              <span className="text-sm font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                {course.levelName}
              </span>
            )}
            {course.language && (
              <span className="text-sm font-semibold text-purple-600 bg-purple-50 px-3 py-1 rounded-full">
                {course.language}
              </span>
            )}
          </div>
          <div className="flex items-center space-x-1 text-yellow-500">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            <span className="font-semibold text-gray-700">{course.rating.toFixed(1)}</span>
            <span className="text-sm text-gray-500">({course.totalStudents} students)</span>
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2">
          {course.title}
        </h1>
        
        {course.subtitle && (
          <h2 className="text-xl text-gray-700 mb-4 font-medium">
            {course.subtitle}
          </h2>
        )}
        
        <p className="text-gray-600 text-lg mb-6 leading-relaxed">
          {course.description}
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
          <div className="transform transition-all duration-300 hover:scale-105">
            <div className="text-xl font-bold text-gray-900">{course.totalStudents}</div>
            <div className="text-sm text-gray-500">Total Students</div>
          </div>
          {/* <div className="transform transition-all duration-300 hover:scale-105">
            <div className="text-xl font-bold text-gray-900">{course.lectures}</div>
            <div className="text-sm text-gray-500">Lectures</div>
          </div> */}
          <div className="transform transition-all duration-300 hover:scale-105">
            <div className="text-xl font-bold text-gray-900">{course.duration}</div>
            <div className="text-sm text-gray-500">Duration</div>
          </div>
          <div className="transform transition-all duration-300 hover:scale-105">
            <div className="text-xl font-bold text-gray-900">{course.completionRate}%</div>
            <div className="text-sm text-gray-500">Completion Rate</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseHeaderContent;